<template>
  <div>
    <FormItemWrapper :form-id="formId" :errors="errors" :label="label">
      <AttachFileForm
        v-model="modelValue"
        :form-id="formId"
        :file-limit="fileLimit"
        :file-min="fileMin"
        :max-file-size-mb="maxFileSizeMb"
        :accept="accept"
        :base64="base64"
        class="w-full"
      />
    </FormItemWrapper>
  </div>
</template>

<script setup lang="ts">
import { AttachFileForm } from "/@/vue/components/Atom";
import { FormItemWrapper } from "/@/vue/components/Molecules";
import { ZodFormattedErrors } from "/@/types";

withDefaults(
  defineProps<{
    formId: string;
    label?: string;
    fileLimit?: number;
    fileMin?: number;
    maxFileSizeMb?: number;
    accept?: string;
    errors: ZodFormattedErrors;
    base64?: boolean;
  }>(),
  {
    accept: ".pdf,.docx,.doc,image/*",
    basee64: true,
  }
);

const modelValue = defineModel<string[] | File[]>();
</script>

<style scoped></style>
